(() => {
  const optionLabel = (select) => {
    const label = select.closest('.product-details__option-wrapper')?.querySelector('label');
    if (label) return label.textContent.trim();

    return `Option ${Number(select.dataset.productOption || 0) + 1}`;
  };

  const selectedSpecifications = (form) => {
    const specifications = [];

    form.querySelectorAll('select[data-product-option]').forEach((select) => {
      specifications.push(`${optionLabel(select)}: ${select.value}`);
    });

    form.querySelectorAll('[name^="properties["]').forEach((field) => {
      if (!field.value || field.disabled || field.name.includes('__shopify')) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;

      const name = field.name.replace(/^properties\[/, '').replace(/\]$/, '');
      specifications.push(`${name}: ${field.value}`);
    });

    return specifications;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-alternative-payment-link]');
    if (!link) return;

    event.preventDefault();

    const form = link.closest('form');
    const productTitle = link.dataset.productTitle || document.title;
    const productUrl = link.dataset.productUrl || window.location.href;
    const quantity = form?.querySelector('[name="quantity"]')?.value || '1';
    const variant = form?.querySelector('[name="id"]')?.value || '';
    const specifications = form ? selectedSpecifications(form) : [];
    const specificationsText = specifications.length
      ? specifications.join('\n')
      : 'Standard product configuration';

    const message = [
      'Hi, I’m interested in purchasing this item using an alternative payment method.',
      '',
      `Product: ${productTitle}`,
      'Selected specifications:',
      ...specifications.map((specification) => `- ${specification}`),
      ...(specifications.length ? [] : ['- Standard product configuration']),
      `Quantity: ${quantity}`,
      `Product page: ${productUrl}`,
      '',
      'I’m interested in paying by Cash, Bank Wire, Zelle, Venmo, or Cash App.',
      'Please contact me with the available savings and next steps.'
    ].join('\n');

    const params = new URLSearchParams({
      source: 'alternative-payment',
      product: productTitle,
      specifications: specificationsText,
      quantity,
      variant,
      product_url: productUrl,
      message
    });

    window.location.href = `${link.dataset.paymentDestination}?${params.toString()}`;
  });
})();
